<template>
  <div class="innerWarp">
    <div class="banner" :style="`background:url(${imageStateUrl}${$store.state.ticketDetail.museumImg}) 0 0/cover no-repeat`">
      <div class="innerBgColor"></div>
      <div class="museumName">{{$store.state.ticketDetail.ticketName}}</div>
      <div class="reTime">
        开馆时间：{{$store.state.ticketDetail.timeOpen}}-{{$store.state.ticketDetail.timeClose}}
        <span v-if="$store.state.ticketDetail.timeStop">停止入馆时间：{{$store.state.ticketDetail.timeStop}}</span>
      </div>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      museum: {},
      imageStateUrl: ''
    };
  },

  methods: {
    getMuseum() {
      this.$ajax(`/api/admin/front/group/name?museumCode=${this.$store.state.museumCode}`).then((res) => {
        this.$store.state.museumName = res.data
      })
    },

    getticketDetail() {
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$store.state.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax.get(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
      })
    },
  },

  created() {
    this.imageStateUrl = !isNaN(Number(this.$store.state.museumCode)) ? '' : Glob.imgUrl
  },

  mounted() {
    if (!this.$store.state.museumName) {
      this.$store.state.museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode || this.$store.state.museumCode
      this.getMuseum()
      if (!this.$store.state.ticketDetail.id){
        this.getticketDetail()
      }
    }
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .innerWarp{
    .banner{
      height: 4rem;
      width: 9rem;
      // background: url('~@/assets/innerBanner.png') 0 0/contain no-repeat;
      position: fixed;
      top: 0;
      left: 0;
      z-index: -1;
      color: #fff;
      text-align: left;
      padding: 0 0.5rem;
      .museumName{
        font-size: 0.6rem;
        margin-top: 0.7rem;
        font-weight: 500;
        line-height: 1rem;
      }
      .reTime{
        font-size: 0.35rem;
        span{
          margin-left: 0.2rem;
        }
      }
    }
    .content{
      border-radius: 0.7rem 0.7rem 0rem 0rem;
      margin-top: 2.5rem;
      min-height: calc(100vh - 2.5rem);
      background-color: #fff;
      z-index: 2;
      padding: 0.5rem 0;
      position: relative;
    }
  }
</style>
